import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import { SESSION_MANUAL_SUBMISSION_MODAL } from '@instructure/quiz-common';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { Modal } from '@instructure/ui-modal';
import { Heading } from '@instructure/ui-heading';
import { Button, CloseButton } from '@instructure/ui-buttons';
export var ManualSubmissionModal = /*#__PURE__*/function (_Component) {
  function ManualSubmissionModal() {
    var _this2;
    _classCallCheck(this, ManualSubmissionModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ManualSubmissionModal, [].concat(args));
    _defineProperty(_this2, "closeModalOnClick", function () {
      _this2.props.closeModal(SESSION_MANUAL_SUBMISSION_MODAL);
    });
    _defineProperty(_this2, "saveAction", function () {
      _this2.props.submitOutstandingQuizSession(_this2.props.quizSessionId);
      _this2.props.closeModal(SESSION_MANUAL_SUBMISSION_MODAL);
      _this2.props.handleSubmitAndPoll();
      _this2.props.afterSubmit();
    });
    _defineProperty(_this2, "cancelAction", function () {
      _this2.props.closeModal(SESSION_MANUAL_SUBMISSION_MODAL);
    });
    return _this2;
  }
  _inherits(ManualSubmissionModal, _Component);
  return _createClass(ManualSubmissionModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Modal, {
        open: this.props.open,
        label: this.props.studentName,
        mountNode: this.props.mountNode,
        onDismiss: this.closeModalOnClick,
        size: "small"
      }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Heading, null, this.props.studentName), /*#__PURE__*/React.createElement(CloseButton, {
        onClick: this.closeModalOnClick,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), /*#__PURE__*/React.createElement(Modal.Body, null, t('Confirm submission for this attempt.')), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.cancelAction,
        margin: "xxx-small"
      }, t('Cancel')), /*#__PURE__*/React.createElement(Button, {
        onClick: this.saveAction,
        color: "primary",
        margin: "xxx-small"
      }, t('Submit Manually'))));
    }
  }]);
}(Component);
_defineProperty(ManualSubmissionModal, "propTypes", {
  studentName: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  submitOutstandingQuizSession: PropTypes.func.isRequired,
  quizSessionId: PropTypes.string.isRequired,
  mountNode: PropTypes.node,
  handleSubmitAndPoll: PropTypes.func,
  afterSubmit: PropTypes.func
});
_defineProperty(ManualSubmissionModal, "defaultProps", {
  mountNode: null,
  afterSubmit: Function.prototype,
  handleSubmitAndPoll: Function.prototype
});
export default ManualSubmissionModal;